import HomePage from "@/pages/home.page";
import ComingSoonPage from "@/pages/coming-soon.page";
import SchedulePage from "@/pages/schedule.page";
import OurImpactPage from "@/pages/our-impact.page";
import SilentAuctionPage from "@/pages/silent-auction.page";
import StoriesPage from "@/pages/stories.page";
import NewStoryPage from "@/pages/new-story.page";
import ArticlePage from "@/pages/article.page";
import SupportPage from "@/pages/support.page";
import HelpPage from "@/pages/help.page";

const routes = [
  {
    name: "comingSoon",
    path: "/coming-soon",
    component: ComingSoonPage,
  },
  {
    name: "home",
    path: "/",
    component: HomePage,
  },
  {
    name: "OurImpactPage",
    path: "/our-impact",
    component: OurImpactPage,
  },
  {
    name: "SilentAuctionPage",
    path: "/raffle-silent-auction",
    component: SilentAuctionPage,
  },
  {
    name: "schedule",
    path: "/schedule",
    component: SchedulePage,
  },
  {
    name: "support",
    path: "/support",
    component: SupportPage,
  },
  {
    name: "help",
    path: "/help",
    component: HelpPage,
  },
  {
    name: "stories",
    path: "/stories",
    component: StoriesPage,
  },
  {
    name: "newStory",
    path: "/new-story",
    component: NewStoryPage,
  },
  {
    name: "article",
    path: "/article/:id-:title",
    component: ArticlePage,
  },
];

export default routes;
